import { TransactionStatus, TransactionType } from '../models';

export interface TransactionFilter {
  status: TransactionStatus;
  dateRange: string;
  sender: string;
  receiver: string;
  type: TransactionType;
}
